export const wrapperStyles = {
  display: 'flex',
  gap: '4px',
  justifyContent: 'center',
};

export const iconButtonStyles = {
  padding: 0,
};
